import React from "react";
import { AlertTriangle } from "lucide-react";
import { problem } from "../mock";

export default function ProblemSection() {
  return (
    <section className="py-24 lg:py-32 bg-[var(--ink-2)] border-y border-[var(--line)]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-14 items-start">
          <div className="lg:col-span-5 reveal lg:sticky lg:top-28">
            <p className="eyebrow">{problem.eyebrow}</p>
            <h2 className="mt-5 font-serif-display text-4xl sm:text-5xl font-semibold leading-[1.05]">
              {problem.title}
            </h2>
            <p className="mt-6 text-[var(--muted)] leading-relaxed">{problem.intro}</p>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-5">
              {problem.points.map((p, i) => (
                <div
                  key={i}
                  className="card-lux rounded-2xl p-7 reveal"
                  style={{ transitionDelay: `${i * 90}ms` }}
                >
                  <div className="w-11 h-11 rounded-xl bg-[var(--crimson)]/15 flex items-center justify-center mb-5">
                    <AlertTriangle size={20} className="text-[var(--crimson-bright)]" />
                  </div>
                  <h3 className="font-serif-display text-xl font-semibold">{p.title}</h3>
                  <p className="mt-2 text-sm text-[var(--muted)] leading-relaxed">{p.body}</p>
                </div>
              ))}
            </div>

            <div className="mt-6 rounded-2xl p-8 border border-[var(--gold)]/25 bg-[var(--gold)]/[0.04] reveal">
              <p className="text-lg leading-relaxed text-[var(--ivory)]/90">
                {problem.closer}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
